// extracted by mini-css-extract-plugin
module.exports = {"passwordInputBox":"project-module--passwordInputBox--1YrQy","passwordInputText":"project-module--passwordInputText--2vvEE"};